import { API_ENDPOINTS } from '../../config/api.js';
import { makeApiRequest } from '../apiClient.js';

export const fileConfigurationService = {
  saveFile: async (data) => {
    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.SAVE_FILE_ANALYTICS,
        method: 'POST',
        data,
        contentType: 'form',
        accessToken: localStorage.getItem('accessToken'),
      });
      return response.data;
    } catch (error) {
      console.error('Save file configuration error:', error);
      throw error;
    }
  },
  updateFileConfig: async (data, id) => {
    try {
      const response = await makeApiRequest({
        endpoint: `${API_ENDPOINTS.UPDATE_FILE_ANALYTICS}?id=${id}`,
        method: 'POST',
        data,
        contentType: 'form',
        accessToken: localStorage.getItem('accessToken'),
      });
      return response.data;
    } catch (error) {
      console.error('Update file configuration error:', error);
      throw error;
    }
  },
  deleteFileConfig: async (data) => {
    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.DELETE_FILE_ANALYTICS,
        method: 'POST',
        data,
        accessToken: localStorage.getItem('accessToken'),
      });
      return response.data;
    } catch (error) {
      console.error('Delete file configuration error:', error);
      throw error;
    }
  },
  getConnectionstring: async (data) => {
    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.GET_CONNECTION_STRING,
        method: 'POST',
        data,
        accessToken: localStorage.getItem('accessToken'),
      });
      return response.data;
    } catch (error) {
      console.error('Get connection string error:', error);
      throw error;
    }
  },
  getFileConfigByCompanyId: async (companyID) => {
    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.GET_FILE_ANALYTICS_BY_ID,
        method: 'POST',
        data: { companyID },
        accessToken: localStorage.getItem('accessToken'),
      });
      return response.data;
    } catch (error) {
      console.error('Get file config by ID error:', error);
      throw error;
    }
  },
  getCloudFileStorageType: async () => {
    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.GET_CLOUD_FILE_STORAGE_TYPE,
        method: 'GET',
        accessToken: localStorage.getItem('accessToken')
      })
      return response.data;
    } catch (error) {
      console.log('get cloud storage type error:', error);
      throw error;
    }
  },
  getCloudFileList: async (data) => {
    try {
      let response;
      if(data.storageType === 'AWS S3') {
        response = await makeApiRequest({
        endpoint: API_ENDPOINTS.GET_AWS_S3_FILE_LIST,
        method: 'POST',
        data,
        accessToken: localStorage.getItem('accessToken')
      })
      }
      else if(data.storageType === 'Azure') {
        response = await makeApiRequest({
          endpoint: API_ENDPOINTS.GET_AZURE_FILE_LIST,
          method: 'POST',
          data,
          accessToken: localStorage.getItem('accessToken')
        })
      }
      else if(data.storageType === 'SFTP') {
        response = await makeApiRequest({
          endpoint: API_ENDPOINTS.GET_SFTP_FILE_LIST,
          method: 'POST',
          data,
          accessToken: localStorage.getItem('accessToken')
        })
      }
      return response.data;
    } catch (error) {
      console.error('Get file list error:', error);
      throw error;
    }
  },
  saveCloudFile: async (data) => {
    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.SAVE_CLOUD_FILE,
        method: 'POST',
        data,
        accessToken: localStorage.getItem('accessToken')
      })
      return response.data;
    } catch (error) {
      console.log('save cloud file error:', error);
      throw error;
    }
  },
  updateCloudFile: async(data) => {
    try {
      const response = await makeApiRequest({
        endpoint: API_ENDPOINTS.UPDATE_CLOUD_FILE,
        method: 'POST',
        data,
        accessToken: localStorage.getItem('accessToken')
      })
      return response.data;
    } catch (error) {      
      console.log('update cloud file error:', error);
      throw error;
    }
  }
};
